import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { carIcon } from './mapIcons';

export default function LiveMap({ vehicles, center }) {
  const defaultCenter = [48.8566, 2.3522];
  return (
    <MapContainer
      center={center || defaultCenter}
      zoom={13}
      className="w-full h-64 rounded-2xl z-0"
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {vehicles.map((v) => (
        <Marker key={v.driverId} position={[v.lat, v.lng]} icon={carIcon}>
          <Popup>{[v.model, v.color].filter(Boolean).join(' · ') || v.driverName}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
